var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteConfrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.098,
    height: 52.098,
    viewBox: "0 0 52.098 52.098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M31.836,29.01l-6.6-6.6,6.6-6.6a2,2,0,0,0-2.83-2.83l-6.6,6.6-6.6-6.6a2,2,0,1,0-2.83,2.83l6.6,6.6-6.6,6.6a1.935,1.935,0,0,0,0,2.83,1.988,1.988,0,0,0,2.83,0l6.6-6.6,6.6,6.6a2.011,2.011,0,0,0,2.83,0A1.988,1.988,0,0,0,31.836,29.01Z",
    transform: "translate(7.018 7.014)",
    fill: "#e53737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M29.424,6.882A22.546,22.546,0,0,1,45.367,45.367,22.546,22.546,0,0,1,13.482,13.482a22.393,22.393,0,0,1,15.943-6.6m0-3.507A26.049,26.049,0,1,0,55.473,29.424,26.045,26.045,0,0,0,29.424,3.375Z",
    transform: "translate(0 0)",
    fill: "#e53737"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteConfrm);
export default __webpack_public_path__ + "static/media/delete_confrm.5da2321871ab25829cd526c5cabf5c08.svg";
export { ForwardRef as ReactComponent };